<template>
  <div class="q-page">
    <div class="container py-5">

      <!-- Breadcrumb -->
      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb q-breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Inicio</router-link></li>
          <li class="breadcrumb-item active">Contacto</li>
        </ol>
      </nav>

      <p class="q-section-title">Contactanos</p>

      <div class="row g-5">

        <!-- Contact form -->
        <div class="col-lg-7">
          <div class="q-contact-card">
            <h2 class="q-contact-card__title">Envianos un mensaje</h2>
            <form @submit.prevent="sendEmail">
              <div class="row g-3 mb-3">
                <div class="col-sm-6">
                  <label class="q-form-label">Tu nombre *</label>
                  <input v-model="form.name" type="text" class="form-control form-control-lg" required placeholder="Ej: Juan Perez" />
                </div>
                <div class="col-sm-6">
                  <label class="q-form-label">Tu email *</label>
                  <input v-model="form.email" type="email" class="form-control form-control-lg" required placeholder="Ej: qupro@mail.com" />
                </div>
              </div>
              <div class="row g-3 mb-3">
                <div class="col-sm-6">
                  <label class="q-form-label">Teléfono</label>
                  <input v-model="form.phone" type="tel" class="form-control form-control-lg" placeholder="Ej: 123456789" />
                </div>
                <div class="col-sm-6">
                  <label class="q-form-label">Empresa</label>
                  <input v-model="form.company" type="text" class="form-control form-control-lg" placeholder="Ej: QUPRO Company" />
                </div>
              </div>
              <div class="mb-3">
                <label class="q-form-label">Tu mensaje</label>
                <textarea v-model="form.message" class="form-control" rows="6" placeholder="Escribe tu mensaje aqui..."></textarea>
              </div>
              <button type="submit" class="btn btn-lg btn-primary">
                <i class="bi bi-send me-2"></i>Enviar mensaje
              </button>
            </form>
          </div>
        </div>

        <!-- Contact info -->
        <div class="col-lg-5">
          <div class="q-contact-info" v-if="contact">
            <h2 class="q-contact-card__title">Información de contacto</h2>

            <ul class="q-info-list">
              <li v-if="contact.address1">
                <span class="q-info-icon"><i class="bi bi-geo-alt"></i></span>
                <span>{{ contact.address1 }}<span v-if="contact.address2">, {{ contact.address2 }}</span></span>
              </li>
              <li v-if="contact.phone1">
                <span class="q-info-icon"><i class="bi bi-telephone"></i></span>
                <span>{{ contact.phone1 }}<span v-if="contact.phone2"> / {{ contact.phone2 }}</span></span>
              </li>
              <li v-if="contact.email">
                <span class="q-info-icon"><i class="bi bi-envelope"></i></span>
                <span>{{ contact.email }}</span>
              </li>
              <li v-if="contact.workhours">
                <span class="q-info-icon"><i class="bi bi-clock"></i></span>
                <span>{{ contact.workhours }}</span>
              </li>
            </ul>

            <!-- Social -->
            <div class="mt-4" v-if="networks">
              <p class="q-form-label mb-3">Redes sociales</p>
              <div class="d-flex gap-2 flex-wrap">
                <a v-if="networks.facebook" :href="formatUrl(networks.facebook)" target="_blank" class="q-social facebook-icon"><i class="bi bi-facebook"></i></a>
                <a v-if="networks.twitter"  :href="formatUrl(networks.twitter)"  target="_blank" class="q-social twitter-icon"><i class="bi bi-twitter-x"></i></a>
                <a v-if="networks.instagram" :href="formatUrl(networks.instagram)" target="_blank" class="q-social instagram-icon"><i class="bi bi-instagram"></i></a>
                <a v-if="networks.whatsapp" :href="'https://wa.me/54' + networks.whatsapp" target="_blank" class="q-social whatsapp-icon"><i class="bi bi-whatsapp"></i></a>
                <a v-if="networks.telegram" :href="networks.telegram"              target="_blank" class="q-social telegram-icon"><i class="bi bi-telegram"></i></a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: { name: "", email: "", phone: "", company: "", message: "" },
    };
  },
  computed: {
    ...mapGetters({
      contact:  "ecommerce/contact",
      networks: "ecommerce/networks",
    }),
  },
  methods: {
    sendEmail() { /* backend integration pending */ },
    formatUrl(url) {
      return url && url.startsWith("http") ? url : "http://" + url;
    },
  },
};
</script>

<style scoped>
.q-breadcrumb { background: transparent; padding: 0; margin: 0; }
.q-breadcrumb .breadcrumb-item { font-size: 14px; color: var(--q-text-subtle); }
.q-breadcrumb .breadcrumb-item a { color: var(--q-text-muted); }
.q-breadcrumb .breadcrumb-item a:hover { color: var(--primary-color); }
.q-breadcrumb .breadcrumb-item + .breadcrumb-item::before { color: var(--q-text-subtle); }

.q-contact-card {
  background: var(--q-bg-surface);
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius-lg);
  padding: 28px;
}
.q-contact-card__title {
  font-family: var(--q-font-display);
  font-size: 1rem; font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--q-text);
  margin-bottom: 24px;
}
.q-form-label {
  font-family: var(--q-font-display);
  font-size: 11px; font-weight: 600;
  letter-spacing: 0.1em; text-transform: uppercase;
  color: var(--q-text-muted); display: block; margin-bottom: 6px;
}

.q-contact-info {
  background: var(--q-bg-surface);
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius-lg);
  padding: 28px;
  height: 100%;
}

.q-info-list {
  list-style: none; margin: 0; padding: 0;
  display: flex; flex-direction: column; gap: 16px;
}
.q-info-list li {
  display: flex; align-items: flex-start; gap: 12px;
  font-size: 1rem; color: var(--q-text-muted); line-height: 1.5;
}
.q-info-icon {
  color: var(--primary-color); font-size: 15px; flex-shrink: 0; margin-top: 1px;
}

/* Social icons */
.q-social {
  display: inline-flex; align-items: center; justify-content: center;
  width: 50px; height: 50px; border-radius: 50%;
  color: var(--q-text-muted); border: 1px solid var(--q-border);
  font-size: 30px; position: relative; overflow: hidden;
  transition: all var(--q-transition);
}
.q-social::before {
  content: ''; position: absolute; inset: 0; border-radius: 50%;
  opacity: 0; transition: opacity var(--q-transition);
}
.q-social:hover { color: #fff; border-color: transparent; }
.q-social:hover::before { opacity: 1; }
.q-social i { position: relative; z-index: 1; }
.facebook-icon::before  { background-color: #1877F2; }
.instagram-icon::before { background-image: linear-gradient(135deg, #F58529, #DD2A7B); }
.whatsapp-icon::before  { background-color: #25D366; }
.twitter-icon::before   { background-color: #1DA1F2; }
.telegram-icon::before  { background-color: #0088cc; }
</style>
